var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-album", { attrs: { profil: _vm.profil } }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "albumMainBody" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sideMenu__close",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "profil" })
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "albumList__separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "albumListing__wrap" }, [
            _c("div", { staticClass: "albumList__half --first" }, [
              _c(
                "div",
                {
                  staticClass:
                    "albumList__heading mb-3 d-flex align-items-center justify-content-between"
                },
                [
                  _c("h2", { staticClass: "mb-0" }, [
                    _vm._v("Omaľovánky "),
                    _c("span", {
                      staticClass: "icon --questionMark",
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.show("modalAlbumAnatomia")
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.album.omalovanky
                ? _c(
                    "div",
                    { staticClass: "albumListing__list --omalovanky" },
                    _vm._l(_vm.album.omalovanky, function(omalovanka, index) {
                      return index >= _vm.startIndex &&
                        index <= _vm.endIndex - 4
                        ? _c("div", { staticClass: "albumListing__item" }, [
                            _c(
                              "div",
                              { staticClass: "albumListing__imageWrap" },
                              [
                                _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    src:
                                      "assets/img/album/omalovanky/" +
                                      omalovanka.album_omalovanky_img,
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "albumListing__descriptionWrap" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn --primary",
                                    attrs: {
                                      href:
                                        "assets/img/album/omalovanky/" +
                                        omalovanka.album_omalovanky_pdf,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "icon --download"
                                    }),
                                    _vm._v("Stiahnuť")
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "albumListing__name mb-0" },
                                  [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(
                                          omalovanka.album_omalovanky_nadpis
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        ".pdf / " +
                                          _vm._s(
                                            omalovanka.album_omalovanky_size
                                          )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.album.omalovanky
              ? _c("div", { staticClass: "albumList__half --second" }, [
                  _c(
                    "div",
                    { staticClass: "albumListing__list --omalovanky" },
                    _vm._l(_vm.album.omalovanky, function(omalovanka, index) {
                      return index >= _vm.startIndex + 4 &&
                        index <= _vm.endIndex
                        ? _c("div", { staticClass: "albumListing__item" }, [
                            _c(
                              "div",
                              { staticClass: "albumListing__imageWrap" },
                              [
                                _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    src:
                                      "assets/img/album/omalovanky/" +
                                      omalovanka.album_omalovanky_img,
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "albumListing__descriptionWrap" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn --primary",
                                    attrs: {
                                      href:
                                        "assets/img/album/omalovanky/" +
                                        omalovanka.album_omalovanky_pdf,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "icon --download"
                                    }),
                                    _vm._v("Stiahnuť")
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "albumListing__name mb-0" },
                                  [
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(
                                          omalovanka.album_omalovanky_nadpis
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        ".pdf / " +
                                          _vm._s(
                                            omalovanka.album_omalovanky_size
                                          )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.prevPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --prev",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage - 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "icon --prev" }),
                  _vm._v("Predchádzajúca strana\n            ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nextPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --next",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage + 1)
                    }
                  }
                },
                [
                  _vm._v("\n                Ďalšia strana"),
                  _c("span", { staticClass: "icon --next" })
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAlbumAnatomia",
          staticClass: "modal fade",
          attrs: {
            id: "modalAlbumAnatomia",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalAlbumAnatomiaTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalAlbumAnatomia")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body", staticStyle: { padding: "0" } },
            [
              _c("div", { staticClass: "text-center" }, [
                _c("h2", { staticClass: "text-center" }, [_vm._v("Nápoveda")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-18" }, [
                  _vm._v(
                    "Stiahni si niektorú z týchto krásnych kravičkovských omaľovánok a vyfarbi ju žiarivými farbami. Vytlačenú na papier môžeš vymaľovávať pastelkami, fixkami, alebo farbami. Ak ju stiahneš do tabletu, môžeš ju vymaľovať vo svojej obľúbenej maľovacej appke."
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "albumPages" }, [
      _c("div", { staticClass: "albumPage --first" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --second" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --third" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --fourth" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }